var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 339.15 334.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: url(#linear-gradient);\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.23px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n        opacity: .19;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 66.63,
    y1: 345.63,
    x2: 273.21,
    y2: -12.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08c4d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#10c6cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#27ccb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#4cd790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#80e55b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#c1f818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#daff00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 66.96,
    y1: 345.06,
    x2: 272.88,
    y2: -11.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08c4d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#10c6cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#27ccb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#4cd790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#80e55b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#c1f818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#daff00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 61.02,
    y1: 355.35,
    x2: 278.82,
    y2: -21.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5182e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cc1f34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#b53248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f5267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5a7e92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#17b6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08c4d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "index"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.84,323.14H28.99c-6.97-6.97-10.88-10.88-17.85-17.85V28.16c6.97-6.97,10.88-10.88,17.85-17.85h281.85c6.97,6.97,10.88,10.88,17.85,17.85v277.14l-17.85,17.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M310.84,323.14H28.99c-6.97-6.97-10.88-10.88-17.85-17.85V28.16c6.97-6.97,10.88-10.88,17.85-17.85h281.85c6.97,6.97,10.88,10.88,17.85,17.85v277.14l-17.85,17.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.87,333.45H23.09L.69,311.06v-143.31l1.85,2.61v139.93l21.31,21.31h92.71l1.31,1.85ZM162.76,0H23.09L.69,22.39v55.83l1.85,1.85V23.16L23.85,1.85h137.06l1.85-1.85ZM206.65,0h-23.1l-1.85,1.85h23.1l1.85-1.85ZM248.47,0h-21.02l-1.85,1.85h21.02l1.85-1.85ZM316.75,0h-47.49l-1.85,1.85h48.57l21.31,21.31v287.14l-21.31,21.31h-61.9l1.85,1.85h60.81l22.39-22.39V22.39L316.75,0ZM1.96,151.61c-1.08,0-1.96.88-1.96,1.96s.88,1.96,1.96,1.96,1.96-.88,1.96-1.96-.88-1.96-1.96-1.96ZM1.96,138.9c-1.08,0-1.96.88-1.96,1.96s.88,1.96,1.96,1.96,1.96-.88,1.96-1.96-.88-1.96-1.96-1.96ZM1.96,128.97c-1.08,0-1.96.88-1.96,1.96s.88,1.96,1.96,1.96,1.96-.88,1.96-1.96-.88-1.96-1.96-1.96ZM215.94,332.48c0-1.08-.88-1.96-1.96-1.96s-1.96.88-1.96,1.96.88,1.96,1.96,1.96,1.96-.88,1.96-1.96ZM228.65,332.48c0-1.08-.88-1.96-1.96-1.96s-1.96.88-1.96,1.96.88,1.96,1.96,1.96,1.96-.88,1.96-1.96ZM238.58,332.48c0-1.08-.88-1.96-1.96-1.96s-1.96.88-1.96,1.96.88,1.96,1.96,1.96,1.96-.88,1.96-1.96Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio2);
export default __webpack_public_path__ + "static/media/portfolio 2.702a93636132c86893ab798e4f13161b.svg";
export { ForwardRef as ReactComponent };